import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import {
    fetchCustomerApplianceCommonBugs,
    fetchCustomerAppliances,
    fetchCustomerComplaints,
} from 'src/api/customer/services';
import {
    FETCH_CUSTOMER_APPLIANCES,
    FETCH_CUSTOMER_COMPLAINTS,
    requestCustomerAppliances,
    requestCustomerAppliancesFailure,
    requestCustomerAppliancesSuccess,
    requestCustomerComplaints,
    requestCustomerComplaintsFailure,
    requestCustomerComplaintsSuccess,
} from './actions';

/* Customer Appliance */
function* fetchCustomerAppliancesSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerAppliances());

    const { error, response } = yield call(fetchCustomerAppliances);
    if (error) yield put(requestCustomerAppliancesFailure(error));
    else {
        const data: unknown[] = [];
        let failState = false;

        // Foreach appliance we also fetch the common bugs
        for (const appliance of response.data) {
            // If there is no id add appliance and empty array for common bugs
            if (!appliance.id) {
                data.push({ ...appliance, commonBugs: [] });
                continue;
            }

            // Fetch the common bugs for this applinace
            const { error: bugsError, response: bugsResponse } = yield call(
                fetchCustomerApplianceCommonBugs,
                appliance.id
            );

            // If bugs request failed stop looping over the rest and put failure
            if (bugsError) {
                failState = true;
                yield put(requestCustomerAppliancesFailure(error));
                break;
            }

            // Add the appliance with its common bugs
            data.push({ ...appliance, commonBugs: bugsResponse.data });
        }

        // If all went well we put success
        if (!failState) yield put(requestCustomerAppliancesSuccess({ ...response, data }));
    }
}

export function* generateFetchCustomerAppliancesWatcher() {
    yield takeLatest(FETCH_CUSTOMER_APPLIANCES, fetchCustomerAppliancesSaga);
}

/* Customer Complaints */
function* fetchCustomerComplaintsSaga(action: AnyAction): SagaIterator {
    yield put(requestCustomerComplaints());

    const { error, response } = yield call(fetchCustomerComplaints);

    if (error) yield put(requestCustomerComplaintsFailure(error));
    else yield put(requestCustomerComplaintsSuccess(response));
}

export function* generateFetchCustomerComplaintsWatcher() {
    yield takeLatest(FETCH_CUSTOMER_COMPLAINTS, fetchCustomerComplaintsSaga);
}
